import {NgModule} from '@angular/core';
import {Scan3dRepository} from './impl/service/ngrx/scan3d.repository';
import {Scan3dDataService} from './impl/service/ngrx/scan3dData.service';
import {Scan3dDataServiceAdapter} from './impl/service/ngrx/scan3dDataService.adapter';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {Scan3dConverter} from './api/entity/converter/scan3d.converter';

@NgModule({
    providers: [
        Scan3dConverter,

        Scan3dRepository,
        Scan3dDataService,
        Scan3dDataServiceAdapter,
    ],
})
export class Scan3dCommonModule {
     constructor(entityDataService: EntityDataService,
                 entityServices: EntityServices,
                 repository: Scan3dRepository,
                 dataService: Scan3dDataService,
    ) {

        entityDataService.registerServices({
            Scan3d: dataService,
        });

        entityServices.registerEntityCollectionServices({
            Scan3d: repository,
        });

        // errorMessages.set(PARTNER_SAVE_PERSON_ALREADY_PART_OF_THIS_TYPE, 'La personne sélectionnée est déjà %1');
    }
}
